import '@/assets/index.css';
import { Init } from '@/init';
import { useAppStore } from '@/store';
import TDesignChat from '@tdesign-vue-next/chat';
import '@tdesign-vue-next/chat/es/style/index.css';
import 'echarts-wordcloud';
import { createPinia } from 'pinia';
import 'uno.css';
import { createApp } from 'vue';
import App from './App.vue';
import { FormI18nKey } from './components/form-generator/utils/context';
import { setupPermissionComponent } from './components/permission';
import { setupPermissionDirective } from './directives/permission';
import i18n from './i18n';
import { mobileClient } from './mobile';
import router from './router';

const app = createApp(App);
const pinia = createPinia();

// 按顺序初始化核心功能
app.use(pinia);
app.use(i18n);
app.use(TDesignChat);
// 提供 i18n 实例给整个应用
app.provide(FormI18nKey, i18n);

// 确保 i18n 初始化完成后再初始化其他功能ˇ
mobileClient.addMobileRouteToRouter(router);
useAppStore().initial(router);
app.use(router);

// 最后初始化权限相关功能
setupPermissionComponent(app);
setupPermissionDirective(app);

// 最后挂载应用和初始化
app.mount('#app');
Init(app);
